import { resolveSectionClasses } from "@/storyblok/resolvers";
import { JobOfferIntroBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";

export default function JobOfferIntro({
  data,
}: {
  data: JobOfferIntroBlockData;
}) {
  return (
    <section
      id={data.anchor}
      className={resolveSectionClasses(data, "container  section--columns-row")}
      {...makeEditable(data)}
      style={{
        "--color-background": data.block_background_color?.color,
      }}
    >
      <div className="col">
        <h3>{data.left_title}</h3>
        <div
          dangerouslySetInnerHTML={{
            __html: renderRichText(data.left_content),
          }}
        ></div>
      </div>
      <div className="col">
        <h3>{data.right_title}</h3>

        <div
          dangerouslySetInnerHTML={{
            __html: renderRichText(data.right_content),
          }}
        ></div>
      </div>
    </section>
  );
}
